import React from 'react';
import {
  Check,
  AlertTriangle,
} from 'lucide-react';

// Green-check bullet (a capability the number HAS).
/**
 * Green-check bullet — a capability the number HAS.
 * @param {{ children: import('react').ReactNode }} props
 */
export function GoodBullet({ children }) {
  return (
    <li className="flex items-start gap-2 text-xs text-white/75">
      <Check className="w-3.5 h-3.5 text-emerald-400 shrink-0 mt-0.5" /> <span>{children}</span>
    </li>
  );
}

// Warning bullet (a limitation / caveat).
/**
 * Warning bullet — a limitation or caveat.
 * @param {{ children: import('react').ReactNode }} props
 */
export function WarnBullet({ children }) {
  return (
    <li className="flex items-start gap-2 text-xs text-amber-200/90">
      <AlertTriangle className="w-3.5 h-3.5 text-amber-400 shrink-0 mt-0.5" /> <span>{children}</span>
    </li>
  );
}
